import { pipe } from 'fp-ts/function';
import * as O from 'monocle-ts/Optional';
import { Action } from 'redux-saga';
import { Future, FUTURE } from 'src/modules/common/types/Future';
import {
  SHARE_PROJECT_CHANGE_OWN_ROLE_OPEN,
  SHARE_PROJECT_CHANGE_OWN_ROLE_CLOSE,
  SHARE_PROJECT_CHANGE_OWN_ROLE_SUBMIT,
} from 'src/modules/sharing-projects/actions/ShareProjectActions';
import { ShareProjectChangeOwnRole, ShareProjectState } from 'src/modules/sharing-projects/types/ShareProjectState';

export function shareProjectChangeOwnRoleReducer(state: ShareProjectState, action: Action): ShareProjectState {
  if (SHARE_PROJECT_CHANGE_OWN_ROLE_OPEN.is(action)) {
    return pipe(state, modifyRole({
      user: action.data.user,
      role: action.data.role,
      status: null,
    }));
  }
  if (SHARE_PROJECT_CHANGE_OWN_ROLE_CLOSE.is(action)) {
    return pipe(state, modifyRole(null));
  }

  if (SHARE_PROJECT_CHANGE_OWN_ROLE_SUBMIT.isPending(action)) {
    return pipe(state, modifyStatus(FUTURE.pending()));
  }

  if (SHARE_PROJECT_CHANGE_OWN_ROLE_SUBMIT.isSuccess(action)) {
    if (state.data && state.data.sharedUsers.state === 'success') {
      return {
        ...state,
        data: {
          ...state.data,
          sharedUsers: FUTURE.success(state.data.sharedUsers.value.map((user) => {
            if (user.id === action.data.user.id) {
              return {
                ...action.data.user,
                role: action.data.role,
              };
            }

            return user;
          })),
          changingOwnRole: null,
        },
      };
    }

    return state;
  }
  if (SHARE_PROJECT_CHANGE_OWN_ROLE_SUBMIT.isFailure(action)) {
    return pipe(state, modifyStatus(FUTURE.failure(action.data)));
  }

  return state;
}

const dataLens = pipe(
  O.id<ShareProjectState>(),
  O.prop('data'),
  O.fromNullable,
);

function modifyRole(
  value: ShareProjectChangeOwnRole | null,
): (state: ShareProjectState) => ShareProjectState {
  return pipe(
    dataLens,
    O.prop('changingOwnRole'),
    O.modify(() => value),
  );
}

function modifyStatus(
  value: Future<void>,
): (state: ShareProjectState) => ShareProjectState {
  return pipe(
    dataLens,
    O.prop('changingOwnRole'),
    O.fromNullable,
    O.prop('status'),
    O.modify(() => value),
  );
}
